import {decodeToken, getToken} from "../utils/tokenManager";
import {apiUrls} from "../constants/apiUrls";
import newApiCall from "../utils/apiCall";

const AuthService = {

    initContext() {
        const accessToken = getToken();
        if (!accessToken ) return null;

        const decode = decodeToken(accessToken);
        if (!decode) return null;

        return { accessToken, decode };
    },

    async login(login, password) {
        const res = await newApiCall.post(
            apiUrls.authorization.login, {
                login, password
            });

        if (!res.data) return null;
        return res;
    },

    async logout() {
        await newApiCall.post(apiUrls.authorization.logout);

    },

    async refreshToken() {
        console.log("обновляем токен")
        const res = await newApiCall.post(apiUrls.authorization.refreshToken)

        if (!(res.status === 500) ) return null;

        return res;
    }
}

export default AuthService;